import {isEmpty, memoize} from 'lodash';
import {API_RESOURCES, createApiCreateAction, createApiReadAction, createApiUpdateAction, createApiDeleteAction} from '../../common/utils/api';
import {normalize, setThousandSeparator} from '../../common/utils/utils';

export const initialState = {};

export const CREATE = 'users/create';
export const GET_BY_ID = 'users/get/byId';
export const GET_ALL = 'users/get/all';
export const PUT = 'users/put';
export const SWITCH_THEME = 'users/theme/switch';
export const CREATE_DELEGATE = 'users/delegate';
export const DELETE_DELEGATE = 'users/delegate/delete';

const _setThousandSeparator = memoize((numberFormat) => setThousandSeparator(numberFormat));

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case CREATE:
			return action.response || state;
		case GET_BY_ID:
			return {
				...state,
				...action.response,
				isPreferencesLoaded: true,
				..._setThousandSeparator(action.response?.numberFormat)
			};
		case GET_ALL:
			return {
				...state,
				search: normalize(action.response.users, 'objectId')
			};
		case PUT:
			return !isEmpty(action.response)
				? {
						...action.response,
						isPreferencesLoaded: true,
						..._setThousandSeparator(action.response?.numberFormat)
					}
				: state;

		// TODO: Remove
		case 'budgets/users/update/gui':
			return {
				...state,
				id: action.userGui
			};

		case SWITCH_THEME:
			return {
				...state,
				theme: action.theme
			};

		default:
			return state;
	}
}

export function createUser(data) {
	return createApiCreateAction(
		CREATE,
		{
			[API_RESOURCES.USERS]: undefined
		},
		data
	);
}

export function getUserById(userId = 'Me') {
	return createApiReadAction(GET_BY_ID, {
		[API_RESOURCES.USERS]: userId
	});
}

export function getAllUsers(queryString) {
	return createApiReadAction(
		GET_ALL,
		{
			[API_RESOURCES.USERS]: undefined
		},
		queryString
	);
}

export function updateUser(userId = 'Me', data) {
	return createApiUpdateAction(
		PUT,
		{
			[API_RESOURCES.USERS]: userId
		},
		data
	);
}

export function switchTheme(theme = 'light') {
	return {
		type: SWITCH_THEME,
		theme
	};
}

export function createDelegate(data) {
	return createApiCreateAction(
		CREATE_DELEGATE,
		{
			[API_RESOURCES.USERS]: 'Delegate'
		},
		data
	);
}

export function removeDelegateUser(id, userId) {
	return createApiDeleteAction(DELETE_DELEGATE, {
		[API_RESOURCES.USERS]: `${id}/Delegate/${userId}`
	});
}
